import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4cb0dcb0&"
import script from "./update-image.js?vue&type=script&lang=js&"
export * from "./update-image.js?vue&type=script&lang=js&"
import style0 from "./update-image.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports